import React from "react";
import { AuthContext } from "../context/AuthState";
import { Route, Routes, Link } from "react-router-dom";
import WebhooksList from "../pages/WebhooksList";
import Webhook from "../pages/webhook";
import Login from "../pages/Login";
import * as Icon from "@ant-design/icons";
import { Button, Col, Row, Skeleton, Typography } from "antd";
import { Header } from "antd/es/layout/layout";
import EditWebhook from "./EditWebhook";
import WebhookLog from "./WebhookLog";
import Wrapper from "./Wrapper";

function PublicRoutes() {
  return (
    <Routes>
      <Route element={<Login />} path="/" />
      <Route element={<Login />} path="*" />
    </Routes>
  );
}

export default function AuthRoutes() {
  const { isAuthenticated, isLoading, logOut, user } =
    React.useContext(AuthContext);
  React.useEffect(() => {}, [isAuthenticated]);

  if (isLoading) {
    return <Skeleton avatar paragraph={{ rows: 4 }} />;
  }
  return isAuthenticated ? (
    <>
      <Header
        title=""
        style={{
          backgroundColor: "#1677ff",
        }}
      >
        <Row style={{ justifyContent: "space-between" }}>
          <Col
            style={{
              display: "flex",
              gap: "20px",
              alignItems: "center",
            }}
          >
            <Link to={"/"}>
              <Typography.Text
                color="#ffffff"
                style={{ fontWeight: "bold", fontSize: "16px", color: "#fff" }}
              >
                KEOS Webhook
              </Typography.Text>
            </Link>
            <span style={{ color: "rgb(244, 196, 48)" }}>
              <Icon.UserOutlined /> <strong> {user.name}</strong>
            </span>
          </Col>
          <Col>
            <Button onClick={logOut} type="text">
              <Typography.Text
                style={{
                  color: "#ff0000",
                  textTransform: "uppercase",
                  fontWeight: "bold",
                }}
              >
                Desconectar
              </Typography.Text>
            </Button>
          </Col>
        </Row>
      </Header>

      <Wrapper>
        <Routes>
          <Route element={<WebhooksList />} path="/" />
          <Route element={<Webhook />} path="/add" />
          <Route element={<WebhookLog />} path="/:webhookId" />
          <Route element={<EditWebhook />} path="/:webhookId/update" />
        </Routes>
      </Wrapper>
    </>
  ) : (
    <PublicRoutes />
  );
}
